/////////////////////////////////////////////////////////////////
// src/utils/payment.js — v11
// CHANGED FROM v10 (5 Aug 2026): REAL FIX — this file imported `auth`
// directly from utils/firebase.js, which broke when firebase.js v2
// switched to deferred/async Auth loading (confirmed via local
// testing before any live push — same root cause and fix as
// AdminPanel.jsx v55). Now imports and calls the async
// getFirebaseAuth() instead, right where startRazorpayPayment()
// actually needs the token. No other logic changed.
import { getFirebaseAuth } from './firebase';
export function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}
export async function startRazorpayPayment({
  amount,
  orderId,
  customerId,
  customerUid,
  customerName,
  customerPhone,
  items,
  itemDetails,
  address,
  shippingType,
  walletUsed,
  onSuccess,
  onFailure,
}) {
  const scriptLoaded = await loadRazorpayScript();
  if (!scriptLoaded) {
    onFailure('Payment gateway failed to load. Please check your connection and try again.');
    return;
  }
  const { auth } = await getFirebaseAuth();
  if (!auth.currentUser) {
    onFailure('You are not signed in. Please sign in and try again.');
    return;
  }
  let idToken;
  try {
    idToken = await auth.currentUser.getIdToken();
  } catch (tokenErr) {
    console.error('Failed to get login token:', tokenErr);
    onFailure('Could not verify your login. Please sign in again.');
    return;
  }
  try {
    const response = await fetch('/.netlify/functions/create-payment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        amount,
        orderId,
        customerId,
        customerUid,
        customerName,
        customerPhone,
        items,
        itemDetails: itemDetails || [],
        address,
        shippingType,
        walletUsed,
        idToken,
      }),
    });
    const data = await response.json();
    if (!data.success) {
      onFailure(data.error || 'Could not start payment. Please try again.');
      return;
    }
    const options = {
      key: data.keyId,
      amount: data.amount,
      currency: data.currency,
      name: 'nobrand store',
      description: `Order ${orderId}`,
      order_id: data.orderId,
      prefill: {
        name: customerName || '',
        contact: customerPhone || '',
        email: 'nobrandstore3@gmail.com',
      },
      theme: { color: '#1B2A4A' },
      handler: function (razorpayResponse) {
        onSuccess(razorpayResponse);
      },
      modal: {
        ondismiss: function () {
          onFailure('Payment cancelled.');
        },
      },
    };
    const razorpayInstance = new window.Razorpay(options);
    razorpayInstance.open();
  } catch (err) {
    console.error('startRazorpayPayment error:', err);
    onFailure('Something went wrong starting payment. Please try again.');
  }
}